var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 0C15.5746 0 7.50012 8.0745 7.50012 18V19.2562L4.57737 28.026C4.42512 28.4835 4.50162 28.986 4.78362 29.3775C5.06562 29.769 5.51787 30 6.00012 30H7.50012V36C7.50012 38.4818 9.51837 40.5 12.0001 40.5H16.5001V46.5C16.5001 47.328 17.1721 48 18.0001 48H36.0001C36.8281 48 37.5001 47.328 37.5001 46.5V36C37.5001 33.7065 38.5869 31.8322 39.8446 29.6625C41.5584 26.7075 43.5001 23.358 43.5001 18C43.5001 8.0745 35.4256 0 25.5001 0Z",
    fill: "url(#paint0_linear_1040_60)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 6C18.8835 6 13.5 11.3835 13.5 18C13.5 19.824 13.9222 21.1335 14.7922 22.0042C15.579 22.7925 16.686 23.1757 18.177 23.1757C19.1295 23.1757 20.1885 23.0302 21.309 22.8757C22.5863 22.6995 24.033 22.5 25.5 22.5C26.967 22.5 28.4138 22.6995 29.691 22.875C30.8123 23.0295 31.8713 23.175 32.8237 23.175C35.9265 23.175 37.5 21.4342 37.5 18C37.5 11.3835 32.1165 6 25.5 6Z",
    fill: "url(#paint1_linear_1040_60)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1040_60",
    x1: 10.3599,
    y1: 40.9808,
    x2: 42.1419,
    y2: 9.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1040_60",
    x1: 17.58,
    y1: 24.792,
    x2: 33.417,
    y2: 8.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA677"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.28b54cb56d8cf000061dcf21fbd92242.svg";
export { ForwardRef as ReactComponent };